import type React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';

import { CollectionList } from 'app/ui/components/molecules/library-collections';

import type { Collection } from 'app/types/graphql';

const Wrapper = styled.div`
  margin-top: 2rem;
`;

type LibraryChallengeCollectionsProps = {
  collections: Collection[];
};

const LibraryChallengeCollections: React.FC<LibraryChallengeCollectionsProps> = ({ collections }) => {
  const intl = useIntl();

  return (
    <Wrapper>
      <CollectionList
        collections={collections}
        title={intl.formatMessage({ id: 'library.challenges' })}
        description={intl.formatMessage({ id: 'library.challengesCopy' })}
        emptyStateTitle={intl.formatMessage({ id: 'library.noChallenges' })}
      />
    </Wrapper>
  );
};

export default LibraryChallengeCollections;
